// Pure validation + payload helpers for the registration form.
import { eventConfig } from "@/config/eventConfig";
import { metaMatchSignals } from "@/lib/analytics";

const emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const sgMobileRe = /^[3689]\d{7}$/;
const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"];

export const EMPTY_FORM = {
  full_name: "",
  mobile: "",
  email: "",
  age_range: "",
  biggest_question: "",
  invited_by: "",
  marketing_consent: false,
};

const orNull = (v) => v || null;

// Returns an errors object; empty when step 1 is valid.
export function validateStepOne(form) {
  const e = {};
  if (!form.full_name || form.full_name.trim().length < 2) e.full_name = "Please enter your full name.";
  if (!sgMobileRe.test(form.mobile.replace(/\D/g, ""))) e.mobile = "Enter a valid 8-digit Singapore mobile number.";
  if (!emailRe.test(form.email.trim())) e.email = "Enter a valid email address.";
  return e;
}

/** Attribution block: UTMs, referral code (URL wins over form) and first-touch data. */
export function normaliseAttribution(attribution = {}, referralCode = "") {
  const utms = Object.fromEntries(UTM_KEYS.map((k) => [k, orNull(attribution[k])]));
  return {
    ...utms,
    referral_code: attribution.referral_code || referralCode || null,
    landing_page_url: attribution.landing_page_url || window.location.href,
    first_visit_at: orNull(attribution.first_visit_at),
  };
}

export function buildRegistrationPayload({ form, attribution, referralCode, metaEventId }) {
  return {
    meta_event_id: metaEventId,
    ...metaMatchSignals(),
    full_name: form.full_name.trim(),
    mobile: form.mobile.replace(/\D/g, ""),
    email: form.email.trim().toLowerCase(),
    age_range: orNull(form.age_range),
    biggest_question: orNull(form.biggest_question),
    invited_by: orNull(form.invited_by),
    marketing_consent: form.marketing_consent,
    event_id: eventConfig.eventId,
    attribution: normaliseAttribution(attribution, referralCode),
  };
}

// Map an API failure to a friendly message.
export function registrationErrorMessage(err) {
  const status = err?.response?.status;
  if (status === 409) return err?.response?.data?.detail || "You're already registered with these details.";
  if (status === 422) return "Please check your details and try again.";
  return "Something went wrong. Please try again.";
}
